import { render, staticRenderFns } from "./StartCreateCalendarTutorialModal.vue?vue&type=template&id=33f8fafe&scoped=true&"
import script from "./StartCreateCalendarTutorialModal.vue?vue&type=script&lang=js&"
export * from "./StartCreateCalendarTutorialModal.vue?vue&type=script&lang=js&"
import style0 from "./StartCreateCalendarTutorialModal.vue?vue&type=style&index=0&id=33f8fafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8fafe",
  null
  
)

export default component.exports